import React from 'react'

class PageNotFound extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="page-not-found base-width">
        <h1>
          PAGE NOT FOUND 404
        </h1>
        Let us go back to your <a href="/">home page.</a>
      </div>
    );
  }
}

export default PageNotFound


// WEBPACK FOOTER //
// ./app/javascript/app/pages/errors/page_not_found/index.jsx